import { Injectable } from '@angular/core';
import { get } from 'lodash';

import { DynamicSearchService } from './dynamic-search.service';
import { ResourceService } from './resource.service';
import { ResourceTypes } from '../interfaces';
import { TestListService } from './testlist.service';

@Injectable()
export class TablelistHandlerService {
  private resourceLoader;

  constructor(
    private dynamicsSearchService: DynamicSearchService,
    private resourceService: ResourceService,
    private testListService: TestListService,
  ) { }

  public resourceHandler(resourceType: ResourceTypes, dynamicSearchQuery?: any): DynamicSearchService | ResourceService | TestListService {
    switch (resourceType) {
      case ResourceTypes.Generic :
        if (dynamicSearchQuery) {
          this.resourceLoader = this.dynamicsSearchService;
        } else {
          this.resourceLoader = this.resourceService;
        }
        break;
      case ResourceTypes.Manual:
        this.resourceLoader = this.testListService;
        break;
      default:
        this.resourceLoader = this.testListService;
    }

    return this.resourceLoader;
  }

  public sort(a: any, b: any, type, key: string, order: number) {
    try {
      const valueA = get(a, key) || '';
      const valueB = get(b, key) || '';

      switch (type.toLowerCase()) {
        case 'date':
          return this.sortByDate(valueA, valueB, order);
        default:
          return this.sortGeneric(valueA, valueB, order);
      }
    } catch (e) {
      return 0;
    }
  }

  public sortByDate(date1, date2, order) {
    if (!(date1 instanceof Date)) {
      date1 = this.parseDate(date1);
    }

    if (!(date2 instanceof Date)) {
      date2 = this.parseDate(date2);
    }

    const result = date1 - date2;

    return result * order;
  }

  private sortGeneric(x, y, order) {
    let normalizedXValue = x;
    let normalizedYValue = y;

    if (typeof x === 'string') {
      normalizedXValue = x.trim().toLowerCase();
    }

    if (typeof y === 'string') {
      normalizedYValue = y.trim().toLowerCase();
    }

    if (normalizedXValue < normalizedYValue) {
      return order * -1;
    }

    if (normalizedXValue > normalizedYValue) {
      return order * 1;
    }

    return 0;
  }

  private parseDate(date) {
    const parsedDate = Date.parse(date);

    return isNaN(parsedDate) ? this.parseNumber(date) : parsedDate;
  }

  private parseNumber(str) {
    const parsedNumber =  Number(str);

    return isNaN(parsedNumber) ? 0 : parsedNumber;
  }
}
